import { ApiError } from '#features/api/utils/ApiError';
import { isContentNotFoundError } from '#features/error/utils/isContentNotFoundError';

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

/** Похоже ли значение из адреса на номер переписки. Остальное на сервер даже не отправляем. */
export const isChatId = (value: string): boolean => UUID_REGEX.test(value);

const NOT_FOUND_PATTERN = /not[\s._-]?found/i;

/**
 * Шлюз ответил, что такой переписки нет.
 *
 * Читающие запросы шлюза отдают отказ не статусом, а телом при HTTP 200: `ApiError` приходит с
 * кодом ответа 200 и сутью только в `errorCode` и тексте. Поэтому одного `status === 404` мало, и
 * несуществующий номер переписки не отличался от сбоя сети. Опознаём по смыслу - "not found" в
 * коде или тексте, - а не по сетевому сбою и не по отказу в доступе: те человеку говорят другое.
 */
export const isChatNotFoundError = (error: unknown): boolean => {
  if (isContentNotFoundError(error)) {
    return true;
  }
  if (!(error instanceof ApiError)) {
    return false;
  }
  return (
    error.status === 404 ||
    NOT_FOUND_PATTERN.test(error.errorCode ?? '') ||
    NOT_FOUND_PATTERN.test(error.message)
  );
};
